__turbopack_context__.v({
  "component": "style-module-scss-module__bgYKiW__component",
});
